export default __webpack_public_path__ + "static/media/Logo Gumbo Mambo - Mascot.32ae9be6.png";